<template>
    <div id="talent-detail">
        <div class="breadcrumb">达人管理 >
            <span>查看达人账号</span>
            <span>
                <el-button class="right_f" type="primary" @click="cancel">返回</el-button>
            </span>
        </div>
        <div class="talent-box">
            <p>基础信息</p>
            <el-row class="talent-info">
                <el-col :span="12">
                    <div class="talent-box-item" v-for="item in infoList">
                        <span class="common-title">{{item.key}}</span>
                        <span class="common-value">{{item.value}}</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="talent-box-item" v-for="item in statisticsList">
                        <span class="common-title">{{item.key}}</span>
                        <span class="common-value">{{item.value}}</span>
                    </div>
                </el-col>
            </el-row>

            <div class="operate-box">
                <p>操作记录</p>
                <el-table :data="operateList" style="overflow-x: auto;">
                    <el-table-column prop="type" label="操作类型"></el-table-column>
                    <el-table-column prop="operationTime" label="操作时间"></el-table-column>
                    <el-table-column prop="reason" label="取消原因"></el-table-column>
                    <el-table-column prop="operator" label="操作人"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                talentId: '',
                infoList: [
                    { key: '姓名：', name: 'name', value: '' },
                    { key: '手机号：', name: 'phoneNumber', value: '' },
                    { key: '达人ID：', name: 'talentId', value: '' },
                    { key: '校区：', name: 'zoneName', value: '' },
                    { key: '院系：', name: 'className', value: '' },
                ],
                statisticsList: [
                    { key: '发视频功能：', name: 'videoEnable', value: '' },
                    { key: '关注数：', name: 'interestNum', value: '' },
                    { key: '粉丝数：', name: 'fansNum', value: '' },
                    { key: '动态数：', name: 'dynamicNum', value: '' },
                    { key: '获赞数：', name: 'praiseNum', value: '' },
                ],
                operateList: []
            }
        },
        mounted() {
            this.talentId = this.$util.getUrlParam('talentId');
            this.getTalentDetail()
        },
        methods: {

            getTalentDetail() {
                let url = this.$util.domain + '/talent/detail?talentId=' + this.talentId;
                
                this.$http({
                    method: "GET",
                    url: url
                }).then(res => {
                    if (res.data.error == 10000) {
                        let preObj = res.data.data;
                        let num = 1;
                        for (let i in preObj) {
                            this.infoList.forEach(item => {
                                if (item.name == i) {
                                    item.value = preObj[i]
                                }
                            })
                            this.statisticsList.forEach(item => {
                                if (item.name == i) {
                                    item.value = i == 'videoEnable' ? (preObj[i] == 1 ? '无' : '有') : preObj[i]
                                }
                            })
                        }
                        preObj.operationLogList.forEach(ele => {
                            let type = '';
                            switch (ele.type * 1) {
                                case 0:
                                    type = '取消达人';
                                    break;
                                case 1:
                                    type = '开通达人';
                                    break;
                                case 2:
                                    type = '取消视频功能';
                                    break;
                                case 3:
                                    type = '开通视频功能';
                                    break;
                                default:
                                    type = '';
                                    break;
                            }
                            this.operateList.push({
                                ...ele,
                                type: type,
                                operationTime: new Date(ele.operationTime).format('yyyy.MM.dd')
                            })
                        })

                    } else {
                        this.$util.errorMsg(res.data.message)
                    }
                }).catch(_=>{
                    this.$util.errorMsg('请求失败')
                })
            },
            cancel() {
                history.go(-1)
            }
        }
    }
</script>
<style scoped>
    .el-dialog--small {
        width: 80% !important;
    }

    .talent-box {
        padding: 0 20px;
        margin-bottom: 20px;
    }

    .talent-box-item {
        color: #666666;
        margin-bottom: 10px;
    }

    .common-title {
        display: inline-block;
        width: 120px;
        text-align: right;
    }

    .talent-box p {
        padding: 10px;
        margin-bottom: 20px;
        background-color: #efefef;
    }

    .talent-info {
        margin-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// talentDetail.vue?dcfa9240